/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { getDashboardData_getDashboardData_salesOutcome as SalesOutComeData } from '../../../gql/types';
import { report_report as ReportResponse } from '../../../gql/types';
import RepComparisonSalesOutcome from '../RepComparisonSalesOutcome';
import { getCookie } from '../../../utils/cookieUtils';

interface ReportSalesOutcomeWidgetProps {
  data1?: SalesOutComeData | null;
  data2?: SalesOutComeData | null;
  reportData?: ReportResponse | null;
  reportData1?: ReportResponse | null;
  isSecond?: boolean;
  activeWeek: number
}
const useStyles = makeStyles({
  page6MainComponent: {
    marginTop: 8,
    padding:'0px 25px'
  },
  page6NextComponent: {
    marginTop: 8,
    padding:'0px 25px'
  },
});

const ReportSalesOutcomeWidget: React.FC<ReportSalesOutcomeWidgetProps> = ({
  data1,
  data2,
  reportData,
  reportData1,
  isSecond,
  activeWeek
}: ReportSalesOutcomeWidgetProps) => {
  const persona = getCookie('persona');
  const numb = persona == 'EXEC' ? 1000 : 1;
  const page6SalesOutcomeData = [
    {
      type: 'amount',
      headingName: 'Pipeline Generated ($ 000)',
      firstPersonTotalValue: 30000, //data1?.totalSalesClosed?.overallTotalSalesClosed,
      secondPersonTotalValue: isSecond ? 1867000 : 2020500, //data2?.totalSalesClosed?.overallTotalSalesClosed,
      avgValue: 1305833.33, //reportData?.salesClosed?.avgSalesClosed! * numb,
      maxValue: 2020500, //reportData?.salesClosed?.maxSalesClosed! * numb,
      minValue: 0, //reportData?.salesClosed?.minSalesClosed! * numb,
    },
    {
      type: 'dealsClosed',
      headingName: 'Pipeline Deals (#)',
      firstPersonTotalValue: 3, //data1?.noOfDeals,
      secondPersonTotalValue: isSecond ? 149 : 127, //data2?.noOfDeals,
      avgValue: 93, //reportData?.dealsClosed?.avgDealsClosed! * numb,
      maxValue: 149, //reportData?.dealsClosed?.maxDealsClosed! * numb,
      minValue: 0, //reportData?.dealsClosed?.minDealsClosed! * numb,
    },
    {
      type: 'dealSizeAmount',
      headingName: 'Booking ($ 000)',
      firstPersonTotalValue: 0,
      // data1?.totalSalesClosed?.overallTotalSalesClosed &&
      // data1?.noOfDeals &&
      // Math.round(
      //   data1?.totalSalesClosed?.overallTotalSalesClosed / data1?.noOfDeals,
      // ),
      secondPersonTotalValue:  isSecond ? 230750 : 214250,
      // data2?.totalSalesClosed?.overallTotalSalesClosed &&
      // data2?.noOfDeals &&
      // Math.round(
      //   data2?.totalSalesClosed?.overallTotalSalesClosed / data2?.noOfDeals,
      // ),
      maxValue: 230750, //reportData?.dealSize?.maxDealSize,
      minValue: 0, //reportData?.dealSize?.minDealSize,
      avgValue: 148333.33, //reportData?.dealSize?.avgDealSize,
    },
    {
      type: 'dealsClosed',
      headingName: 'Deals Closed (#)',
      firstPersonTotalValue: 0, //data1?.noOfDeals,
      secondPersonTotalValue:  isSecond ? 5 : 6, //data2?.noOfDeals,
      avgValue: 3.75, //reportData?.dealsClosed?.avgDealsClosed! * numb,
      maxValue: 6, //reportData?.dealsClosed?.maxDealsClosed! * numb,
      minValue: 0, //reportData?.dealsClosed?.minDealsClosed! * numb,
    },
    {
      type: 'dealSizeAmount',
      headingName: 'Deal Size ($ 000)',
      firstPersonTotalValue: 0,
      //   data1?.quotaAttainment && Math.round(data1?.quotaAttainment),
      secondPersonTotalValue:  isSecond ? 46150 : 35708.33,
      //   data2?.quotaAttainment && Math.round(data2?.quotaAttainment),
      avgValue: 27286.11, //reportData?.quotaAttainment?.avgQuotaAttainment,
      maxValue: 46150, //reportData?.quotaAttainment?.maxQuotaAttainment,
      minValue: 0, //reportData?.quotaAttainment?.minQuotaAttainment,
    },
    {
      type: 'winRatePercentage',
      headingName: 'Win Rate',
      firstPersonTotalValue: 0, //data1?.winRate && Math.round(data1?.winRate),
      secondPersonTotalValue:  isSecond ? 7.25 : 11.5, //data2?.winRate && Math.round(data2?.winRate),
      avgValue: 6.25, //reportData?.winRate?.avgWinRate,
      maxValue: 11.5, //reportData?.winRate?.maxWinRate,
      minValue: 0, //reportData?.winRate?.minWinRate,
    },
    // {
    //   type: 'days',
    //   headingName: 'Sales Cycle (Days)',
    //   firstPersonTotalValue: reportData?.salesCycle?.totalSalesCycle,
    //   secondPersonTotalValue: reportData1?.salesCycle?.totalSalesCycle,
    //   avgValue: reportData?.salesCycle?.avgSalesCycle,
    //   maxValue: reportData?.salesCycle?.maxSalesCycle,
    //   minValue: reportData?.salesCycle?.minSalesCycle,
    // },
  ];
  const page6SalesOutcomeData1 = [
    {
      type: 'amount',
      headingName: 'Pipeline Generated ($ 000)',
      firstPersonTotalValue: 15000, //data1?.totalSalesClosed?.overallTotalSalesClosed,
      secondPersonTotalValue: isSecond ? 76000 : 60000, //data2?.totalSalesClosed?.overallTotalSalesClosed,
      avgValue: 50333.33, //reportData?.salesClosed?.avgSalesClosed! * numb,
      maxValue: 76000, //reportData?.salesClosed?.maxSalesClosed! * numb,
      minValue: 0, //reportData?.salesClosed?.minSalesClosed! * numb,
    },
    {
      type: 'dealsClosed',
      headingName: 'Pipeline Deals (#)',
      firstPersonTotalValue: 1, //data1?.noOfDeals,
      secondPersonTotalValue: isSecond ? 5 : 5, //data2?.noOfDeals,
      avgValue: 3.75, //reportData?.dealsClosed?.avgDealsClosed! * numb,
      maxValue: 5, //reportData?.dealsClosed?.maxDealsClosed! * numb,
      minValue: 0, //reportData?.dealsClosed?.minDealsClosed! * numb,
    },
    {
      type: 'dealSizeAmount',
      headingName: 'Booking ($ 000)',
      firstPersonTotalValue: 0,
      // data1?.totalSalesClosed?.overallTotalSalesClosed &&
      // data1?.noOfDeals &&
      // Math.round(
      //   data1?.totalSalesClosed?.overallTotalSalesClosed / data1?.noOfDeals,
      // ),
      secondPersonTotalValue:  isSecond ? 0 : 16000,
      // data2?.totalSalesClosed?.overallTotalSalesClosed &&
      // data2?.noOfDeals &&
      // Math.round(
      //   data2?.totalSalesClosed?.overallTotalSalesClosed / data2?.noOfDeals,
      // ),
      maxValue: 16000, //reportData?.dealSize?.maxDealSize,
      minValue: 0, //reportData?.dealSize?.minDealSize,
      avgValue: 5333.33, //reportData?.dealSize?.avgDealSize,
    },
    {
      type: 'dealsClosed',
      headingName: 'Deals Closed (#)',
      firstPersonTotalValue: 0, //data1?.noOfDeals,
      secondPersonTotalValue:  isSecond ? 0 : 1, //data2?.noOfDeals,
      avgValue: 0.35, //reportData?.dealsClosed?.avgDealsClosed! * numb,
      maxValue: 1, //reportData?.dealsClosed?.maxDealsClosed! * numb,
      minValue: 0, //reportData?.dealsClosed?.minDealsClosed! * numb,
    },
    {
      type: 'dealSizeAmount',
      headingName: 'Deal Size ($ 000)',
      firstPersonTotalValue: 0,
      //   data1?.quotaAttainment && Math.round(data1?.quotaAttainment),
      secondPersonTotalValue:  isSecond ? 0 : 16000,
      //   data2?.quotaAttainment && Math.round(data2?.quotaAttainment),
      avgValue: 5333.33, //reportData?.quotaAttainment?.avgQuotaAttainment,
      maxValue: 16000, //reportData?.quotaAttainment?.maxQuotaAttainment,
      minValue: 0, //reportData?.quotaAttainment?.minQuotaAttainment,
    },
    {
      type: 'winRatePercentage',
      headingName: 'Win Rate',
      firstPersonTotalValue: 0, //data1?.winRate && Math.round(data1?.winRate),
      secondPersonTotalValue:  isSecond ? 0 : 50, //data2?.winRate && Math.round(data2?.winRate),
      avgValue: 16.33, //reportData?.winRate?.avgWinRate,
      maxValue: 50, //reportData?.winRate?.maxWinRate,
      minValue: 0, //reportData?.winRate?.minWinRate,
    },
    // {
    //   type: 'days',
    //   headingName: 'Sales Cycle (Days)',
    //   firstPersonTotalValue: reportData?.salesCycle?.totalSalesCycle,
    //   secondPersonTotalValue: reportData1?.salesCycle?.totalSalesCycle,
    //   avgValue: reportData?.salesCycle?.avgSalesCycle,
    //   maxValue: reportData?.salesCycle?.maxSalesCycle,
    //   minValue: reportData?.salesCycle?.minSalesCycle,
    // },
  ];

  const classes = useStyles();

  const data = activeWeek > -1 ? page6SalesOutcomeData1: page6SalesOutcomeData

  return (
    <Grid container justify="space-between" direction="column">
      {data.map((item, index) => (
        <Grid
          item
          className={
            index === 0
              ? classes.page6MainComponent
              : classes.page6NextComponent
          }
          key={index}
        >
          <RepComparisonSalesOutcome
            type={item.type}
            firstPersonValue={item.firstPersonTotalValue}
            secondPersonValue={item.secondPersonTotalValue}
            headingName={item.headingName}
            maxValue={item.maxValue}
            minValue={item.minValue}
            avgValue={item.avgValue}
            index={index}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ReportSalesOutcomeWidget;
